import ReactGA from "react-ga4";
export default function useAnalytics(){
    ReactGA.initialize("G-37P4KC8VNX");
    ReactGA.send("pageview");
    return null;
}